import React from 'react';
import { Routes, Route } from "react-router-dom";
import { ReactLenis } from 'lenis/react';

import AutoSEO from '../../utils/AutoSEO';

import Homepage from '../HomePage/HomePage';
import HomePage2 from '../HomePage2/HomePage2';
import HomePage3 from '../HomePage3/HomePage3';
import HomePage4 from '../HomePage4/HomePage4';
import HomePage5 from '../HomePage5/HomePage5';
import HomePage6 from '../HomePage6/HomePage6';
import HomePage7 from '../HomePage7/HomePage7';
import HomePage8 from '../HomePage8/HomePage8';
import HomePage9 from '../HomePage9/HomePage9';
import HomePage10 from '../HomePage10/HomePage10';
import HomePage11 from '../HomePage11/HomePage11';
import HomePage12 from '../HomePage12/HomePage12';
import HomePage13 from '../HomePage13/HomePage13';
import HomePage14 from '../HomePage14/HomePage14';
import HomePage15 from '../HomePage15/HomePage15';
import AboutPage from '../AboutPage/AboutPage';
import ServicePages from '../ServicePage/ServicePage';
import ServiceSinglePage from '../ServiceSinglePage/ServiceSinglePage';
import TeamPages from '../TeamPage/TeamPage';
import TeamSinglePage from '../TeamSinglePage/TeamSinglePage';
import PricingPage from '../PricingPage/PricingPage';
import PrivacePage from '../PrivacePage/PrivacePage';
import TermsPage from '../TermsPage/TermsPage';
import WishlistPage from '../WishlistPage/WishlistPage';
import ProjectPage from '../ProjectPage/ProjectPage';
import ProjectSingle from '../ProjectSingle/ProjectSingle';
import ShopPage from '../ShopPage/ShopPage';
import ShopSingle from '../ShopSingle';
import CartPage from '../CartPage/CartPage';
import CheckoutPage from '../CheckoutPage';
import OrderRecived from '../OrderRecived';
import BlogPage from '../BlogPage/BlogPage';
import BlogPageLeft from '../BlogPageLeft/BlogPageLeft';
import BlogPageFullwidth from '../BlogPageFullwidth/BlogPageFullwidth';
import BlogDetails from '../BlogDetails/BlogDetails';
import BlogDetailsLeftSiide from '../BlogDetailsLeftSiide/BlogDetailsLeftSiide';
import BlogDetailsFull from '../BlogDetailsFull/BlogDetailsFull';
import ContactPage from '../ContactPage/ContactPage';
import LoginPage from '../LoginPage';
import ForgotPassword from '../ForgotPassword';
import Register from '../SignUpPage';
import ErrorPage from '../ErrorPage/ErrorPage';

const AllRoute = () => {
  return (
    <ReactLenis root>
      {/* ✅ AUTO SEO – runs on every route change */}
      <AutoSEO />

      <Routes>
        <Route path="/" element={<Homepage />} />
        <Route path="/home" element={<Homepage />} />

        <Route path="/bliize-classic-architecture" element={<HomePage2 />} />
        <Route path="/bliize-modern-architecture-s2" element={<HomePage3 />} />
        <Route path="/bliize-classic-architecture-dark" element={<HomePage4 />} />
        <Route path="/bliize-classic-interior-design" element={<HomePage5 />} />
        <Route path="/bliize-classic-interior-design-s2" element={<HomePage6 />} />
        <Route path="/bliize-classic-interior-design-dark" element={<HomePage7 />} />
        <Route path="/bliize-renovation" element={<HomePage8 />} />
        <Route path="/bliize-modern-woocommerce" element={<HomePage9 />} />
        <Route path="/bliize-minimal-woocommerce" element={<HomePage10 />} />
        <Route path="/bliize-urban-planning" element={<HomePage11 />} />
        <Route path="/bliize-costruction" element={<HomePage12 />} />
        <Route path="/bliize-costruction-s2" element={<HomePage13 />} />
        <Route path="/bliize-costruction-profile" element={<HomePage14 />} />
        <Route path="/bliize-frelancer-architect" element={<HomePage15 />} />

        <Route path="/about" element={<AboutPage />} />
        <Route path="/services" element={<ServicePages />} />
        <Route path="/service-single/:slug" element={<ServiceSinglePage />} />

        <Route path="/team" element={<TeamPages />} />
        <Route path="/team-single/:slug" element={<TeamSinglePage />} />

        <Route path="/pricing" element={<PricingPage />} />
        <Route path="/privace" element={<PrivacePage />} />
        <Route path="/terms" element={<TermsPage />} />

        <Route path="/projects" element={<ProjectPage />} />
        <Route path="/project-single/:slug" element={<ProjectSingle />} />

        <Route path="/shop" element={<ShopPage />} />
        <Route path="/shop-single/:slug" element={<ShopSingle />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/checkout" element={<CheckoutPage />} />
        <Route path="/wishlist" element={<WishlistPage />} />
        <Route path="/order_received" element={<OrderRecived />} />

        <Route path="/blog" element={<BlogPage />} />
        <Route path="/blog-left-sidebar" element={<BlogPageLeft />} />
        <Route path="/blog-fullwidth" element={<BlogPageFullwidth />} />
        <Route path="/blog-single/:slug" element={<BlogDetails />} />
        <Route path="/blog-single-left-sidebar/:slug" element={<BlogDetailsLeftSiide />} />
        <Route path="/blog-single-fullwidth/:slug" element={<BlogDetailsFull />} />

        <Route path="/contact" element={<ContactPage />} />
        <Route path="/login" element={<LoginPage />} />
        <Route path="/forgot" element={<ForgotPassword />} />
        <Route path="/register" element={<Register />} />

        <Route path="/404" element={<ErrorPage />} />
        <Route path="*" element={<ErrorPage />} />
      </Routes>
    </ReactLenis>
  );
};

export default AllRoute;
